import { isArray } from 'lodash/fp';
import { DateTime } from 'luxon';
import { UTCTimezone } from '../constants';
import { ISOFormat } from '../enums';
import { dateTimeFromFormat } from './dateTimeFromFormat';

const millisecondsSepator = '.';
const maxMillisecondsLength = 3;

const toLuxon = (value: string, formats: ISOFormat | ISOFormat[], zone = UTCTimezone): DateTime => {
    const formatArray = isArray(formats) ? formats : Array.of(formats);

    // Luxon doesn't support microseconds, so we cut them out of the value
    const [, milliseconds] = value.split(millisecondsSepator);
    let finalValue = value;
    if (milliseconds && milliseconds.length > maxMillisecondsLength) {
        finalValue = finalValue.slice(0, maxMillisecondsLength - milliseconds.length);
        finalValue = milliseconds.endsWith('Z') ? `${finalValue}Z` : finalValue;
    }

    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < formatArray.length; i++) {
        const luxon = dateTimeFromFormat(finalValue, formatArray[i], { zone });
        if (luxon.isValid) {
            return luxon;
        }
    }

    throw new TypeError('The argument is not in a supported format: ' + finalValue);
};

export default toLuxon;
